import { render, staticRenderFns } from "./ReceiptRecord.vue?vue&type=template&id=432200be&scoped=true&"
import script from "./ReceiptRecord.vue?vue&type=script&lang=js&"
export * from "./ReceiptRecord.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptRecord.vue?vue&type=style&index=0&id=432200be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432200be",
  null
  
)

export default component.exports